import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { EditTaxeParafiscalePage } from "@/features/ventes/components/tarifs/EditTaxeParafiscalePage";
import { TARIF_PERMISSIONS } from "@/features/ventes/config/tarifs/constants";

export const Route = createFileRoute("/_app/ventes/tarifs/taxes/$id/edit")({
  loader: requirePermission(TARIF_PERMISSIONS.TAXES_EDIT),
  staticData: {
    title: "Modifier taxe parafiscale",
    showInBreadcrumb: true,
  },
  component: EditTaxeParafiscalePage,
});
